<template>
  <div
    class="pos-transition-dialog pos-transition-dialog__backdrop"
    :class="{ 'pos-transition-dialog--open': open }"
    @click="$emit('update:open', false)"
  >
    <md-list
      class="pos-transition-dialog__item-list"
      :style="{ left: position.x, top: position.y }"
    >
      <md-list-item class="pos-transition-dialog__title">
        <div
          v-if="$store.state.isQueryFullFeatured"
          class="pos-transition-dialog__title-set"
        >
          {{ title }}
        </div>
        <div v-else class="disabled-reason">
          {{ msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE }}
        </div>
      </md-list-item>
      <md-list-item
        v-for="dest in destinations"
        :key="dest.resourceName"
        :disabled="!$store.state.isQueryFullFeatured"
        @click.stop="$emit('click', dest.resourceName)"
      >
        {{ dest.label }}
      </md-list-item>
    </md-list>
  </div>
</template>

<script>
import msg from '@/const/messages'
// POS分析の相互遷移するためのダイアログコンポーネント
// Md-Menuならクリックで表示などできるのでそちらを使いたかったのですが、
// 外部から開閉の状態を管理すると開いた瞬間閉じてしまい正常に動作しませんでした。
// しょうがないのでMd-Listを内包する表示非表示制御可能なコンポーネントをこしらえました。
// 表示される遷移先リストは、現在の画面（商品xKPIなど）を自動的に除外します。
// 手動で除外対象を追加したいときなどはもう少し実装が必要です。

export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    trigger: {
      type: PointerEvent,
    },
    title: {
      type: String,
    },
    destinations: {
      type: Array,
    },
  },
  data() {
    return {
      msg,
    }
  },
  computed: {
    position() {
      if (!this.trigger) {
        return { x: undefined, y: undefined }
      }
      return {
        x: `${this.trigger.x}px`,
        y:
          this.trigger.y + (this.destinations.length == 4 ? 48 * 4 : 48 * 5) <=
          window.innerHeight
            ? `${this.trigger.y}px`
            : `${this.trigger.y - 200}px`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pos-transition-dialog {
  z-index: 1000;

  opacity: 0;
  pointer-events: none;

  &__backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &__item-list {
    width: 250px;
    border: 1px solid var(--color-border);
    border-radius: 4px;
  }

  &--open {
    opacity: 1;
    pointer-events: inherit;
  }
  &__title-set {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--color-secondary-text);
  }
}
.disabled-reason {
  font-size: 0.78em;
  color: #999;
  white-space: normal;
  overflow-wrap: break-word;
}
</style>
